module.exports = __webpack_public_path__ + "img/runnninggirl.1370beb5.png";